import * as React from 'react';
import { Text, View, StyleSheet, ViewStyle } from 'react-native';

export interface ItemRowProps {
    style?: ViewStyle;
}
export interface SurveyItemRowProps extends ItemRowProps{
    left: React.ReactNode;
    center: React.ReactNode;
    right: React.ReactNode;
}
export const ItemRow = (props: React.PropsWithChildren<ItemRowProps>) => (
    <View style={[styles.container, props.style]}>
        {props.children}
    </View>
);

export const ThreeItemRow = (props: SurveyItemRowProps) => (
    <ItemRow style={props.style}>
        <View style={{ width: 40, marginRight: 10, alignItems: 'flex-end' }}>
            {props.left}
        </View>
        <View style={{ flex: 1, marginRight: props.right ? 10 : 0 }}>
            {props.center}
        </View>
        <View>
            {props.right}
        </View>
    </ItemRow>
);

const styles = StyleSheet.create({
    container: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: 5
    }
});
